/* eslint-disable react/jsx-props-no-spreading */
import {useTranslation} from 'react-i18next';
import CustomModalHeader from 'components/modal/customModalHeader';
import useUser from 'hooks/useUser';
import {Modal} from 'flowbite-react';
import {useEffect, useRef, useState} from 'react';
import {themModal} from 'utils/theme';
import '../../form/styles.scss';
import './purchaseOrderModal.scss';
import {locationSelector, orgSelector} from 'redux/selectors';
import {useSelector} from 'react-redux';
import {getCategoriesByFilter} from 'api/categoryApi';
import {sortByTypeType, defaultpageCount} from 'utils/constants';
import {useForm} from 'react-hook-form';
import MultiSelect from 'components/select/index'
import GroupButton from 'components/button/groupButton';

type createItemByCategoryModalProps = {
    openModal: boolean,
    setOpenModal: Function,
    headerTitle?: string,
    description?: string,
    confirmText?: string,
    requireSelection?: boolean,
    selectionRequiredMessage?: string,
    category?: any,
    setCategory?: Function,
    onConfirm?: (categoryIds: string[]) => void,
    queryClient?: any,
    setCurrentPage?: any,
    currentPage?: number,
};
const CreateItemByCategoryModal = (props: createItemByCategoryModalProps) => {
    const {
        openModal,
        category,
        setCategory,
        onConfirm,
        setOpenModal,
        headerTitle,
        description,
        confirmText,
        requireSelection = false,
        selectionRequiredMessage,
        currentPage,
        queryClient,
        setCurrentPage
    } = props;
    const {fetchCurrentUser} = useUser();
    const [t] = useTranslation();
    const rootRef = useRef(null);
    const [error, setErrors] = useState(false);
    const {organizationId} = useSelector(orgSelector);
    const {locationId} = useSelector(locationSelector);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [categoryIds, setCategoryIds] = useState([]);
    const [categoryTypeOptions, setCategoryTypeOptions] = useState([{label: '...', value: ''}]);
    const [totalPages, setTotalPages] = useState(0);
    const pageCountDefault = 1000;

    const hookForm = useForm({
        mode: "onChange",
    });

    const {
        register,
        handleSubmit,
        setValue,
        clearErrors,
        setError,
        reset,
        getValues,
    } = hookForm;

    const fetchCategories = async (page = 0, accumulatedData = []) => {
        try {
          const res = await getCategoriesByFilter({
            page,
            limit: pageCountDefault,
            sortByType: sortByTypeType.DESC,
            organizationId,
          });
    
          const totalCount = res?.data?.totalEntities || 0;
          const newData: any = [...accumulatedData, ...(res?.data?.entities || [])];
    
          if (totalCount === 0) {
            setCategoryTypeOptions([]);
            setTotalPages(0);
            return;
          }
    
          const pageBreak = Math.ceil(totalCount / pageCountDefault);
          setTotalPages(pageBreak);
    
          if (page < pageBreak - 1) {
            await fetchCategories(page + 1, newData);
          } else {
            const newOptions = newData.map((item: any) => ({
              label: item.name,
              value: item.id,
            }));
            setCategoryTypeOptions(newOptions);
          }
        } catch (error) {
          console.error('Error fetching categories:', error);
          setCategoryTypeOptions([]);
        } finally {
          
        }
      };

    useEffect(() => {
        fetchCategories();

        // eslint-disable-next-line
    }, []);

    const toggleHandler = () => {
        setOpenModal(!openModal);
    };

    const handleChangeCategory = (options: any) => {
        setSelectedCategory(options);
        setCategoryIds(options.map((i: any) => {
            return i.value
        }));
    };

    const handleOk = () => {
        if (requireSelection && categoryIds.length === 0) {
            setErrors(true);
            return;
        }
        setErrors(false);
        if (onConfirm) {
            onConfirm(categoryIds);
        } else if (setCategory) {
            setCategory(categoryIds);
        }
        toggleHandler();
    }

    return (
        <div ref={rootRef} className="order-modal-container">
            <Modal
                show={openModal}
                size="xl"
                className="order-modal"
                root={rootRef.current ?? undefined}
                onClose={toggleHandler}
                dismissible={false}
                theme={themModal}
            >
                <CustomModalHeader title={headerTitle} toggle={toggleHandler}/>
                <Modal.Body theme={{base: 'flex-12 pb-4 pt-3 px-12'}}>
                    <form>
                        {description && (
                            <div className="text-sm text-gray-600 mb-4">{description}</div>
                        )}
                        <div className="mt-4 relative">
                            <MultiSelect
                                onChange={(option: any) => handleChangeCategory(option)}
                                options={categoryTypeOptions}
                                value={selectedCategory}
                                isMulti={true}
                                hookForm={hookForm}
                                name="categoryId"
                                noOptionsMessage={() => t('No options')}
                                closeMenuOnSelect
                                isHolderLabel={true}
                                placeholder={`${t('orderPage.category')}`}
                            />
                        </div>
                        {error && (
                            <div className="text-red-600 text-sm mt-3">
                                {selectionRequiredMessage || t('orderPage.generatePurchaseOrderCategoryRequired')}
                            </div>
                        )}
                        <GroupButton
                            className="items-center justify-center pt-5 mb-4"
                            buttons={[
                                {
                                    type: 'button',
                                    text: t('modal.cancel'),
                                    classType: 'white',
                                    action: () => toggleHandler(),
                                },
                                {
                                    type: 'button',
                                    text: confirmText || t('modal.ok'),
                                    classType: 'blue',
                                    isLoading: false,
                                    action: () => handleOk(),
                                },
                            ]}
                        />
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
};
export default CreateItemByCategoryModal;
